import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20Korean%20manhwa%20comic%20panels%20with%20warm%20orange%20and%20amber%20gradient%20tones%2C%20dynamic%20motion%20lines%2C%20stylized%20speech%20bubbles%2C%20geometric%20comic%20layout%20patterns%2C%20modern%20flat%20design%2C%20clean%20artistic%20style%2C%20no%20text%2C%20no%20characters&width=1800&height=900&seq=hero-bg-kcomic&orientation=landscape"
        alt="韩国漫画大全 - 免费在线韩漫阅读平台"
        title="韩国漫画大全 - 免费在线韩漫阅读网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            韩漫大全
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-3 max-w-xl mx-auto leading-relaxed">
            收录超万部韩漫作品，全部免费在线阅读
          </p>
          <p className="text-sm md:text-base text-white/60 mb-8 max-w-lg mx-auto leading-relaxed">
            涵盖连载与完结经典之作，每日更新热门韩漫，韩漫爱好者的一站式阅读平台
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
            <Link
              to="/category/rexue"
              className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap px-8 py-3 rounded-full border-2 border-white/40 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-300 cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-6 md:gap-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">10000+</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">收录作品</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">8大</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">分类专题</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">每日</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">持续更新</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-white"></div>
          <div className="w-2 h-2 rounded-full bg-white/40"></div>
          <div className="w-2 h-2 rounded-full bg-white/40"></div>
        </div>
      </div>
    </section>
  );
}